import type { ContractReportDto } from "../../../autogen/bff-api";
import { type SearchedField, searchHitOutsideShownColumns } from "../../../common/entity-table/searchHit";

export const DEPARTMENT_FIELD = "department";

const SEARCHED_FIELDS: SearchedField<ContractReportDto>[] = [
  { key: "title", values: (contract) => [contract.title] },
  { key: "counterparty", values: (contract) => [contract.counterpartyName] },
  { key: "referenceNumber", values: (contract) => [contract.referenceNumber] },
  { key: "projectDetails", values: (contract) => contract.projectDetails?.map((project) => project.projectName) ?? [] },
  { key: "responsible", values: (contract) => [contract.internalOwnerName] },
  { key: DEPARTMENT_FIELD, values: (contract) => [contract.departmentName] },
];

export const contractSearchHitOutsideShownColumns = (
  contract: ContractReportDto,
  term: string | null | undefined,
  shownColumns: Set<string>,
) => searchHitOutsideShownColumns(SEARCHED_FIELDS, contract, term, shownColumns);
